var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"s_upload"},[_c('input',{staticStyle:{"display":"none"},attrs:{"type":"file","accept":_vm.uploadAccept,"id":'s-task-upload' + _vm.idNumber},on:{"change":function($event){return _vm.fileSelected()}}})])}
var staticRenderFns = []

export { render, staticRenderFns }